export type ReadonlyCompanyEndpoints = {
    readonly AddUpdateCompany: string;
    readonly GetCompany: string;
    readonly GetCompanyById: string;
    readonly UpdateCompany: string;
    readonly DeleteCompany: string;
    readonly CheckActiveCompany: string;    
    readonly GetCompaines: string; 
    readonly GetCompanyBySiteId: string; 
  };
  
  const controller = 'api/Company'
  
  const CompanyEndpoints: ReadonlyCompanyEndpoints = {
    AddUpdateCompany: `${controller}/AddUpdateCompany`,
    GetCompany: `${controller}/GetCompaines`,
    GetCompanyById: `${controller}/GetCompanyById`,
    UpdateCompany: `${controller}/AddUpdateCompany`,
    DeleteCompany: `api/Company/DeleteCompany`,
    CheckActiveCompany: `api/Company/CheckActiveCompany`,
    GetCompaines: `${controller}/GetCompaines`, 
    GetCompanyBySiteId: `${controller}/GetCompanyBySiteId`, 
  };
  

 
    export { CompanyEndpoints };